import React from 'react';
import { Link } from 'react-router-dom';
import { CategoryMasterItem } from '../types/categoryMaster.types';

const GRADIENT_COUNT = 6;

const DEFAULT_ICON = '🎨';

interface CategoryCardProps {
    category: CategoryMasterItem;
    index: number;
}

const ChevronRight: React.FC = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18l6-6-6-6" />
    </svg>
);

const BASE_URL = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace('/api/v1', '')
    : 'http://localhost:8000';

const CategoryCard: React.FC<CategoryCardProps> = ({ category, index }) => {
    const { name, slug, image } = category;
    const gradientClass = `cs-card-img-wrap--g${index % GRADIENT_COUNT}`;
    const href = `/categories/${encodeURIComponent(slug)}`;
    const imageUrl = image ? `${BASE_URL}${image}` : null;

    return (
        <Link to={href} className="cs-card">
            <div className={`cs-card-img-wrap ${imageUrl ? 'cs-card-img-wrap--photo' : gradientClass}`}>
                {imageUrl ? (
                    <>
                        <img
                            src={imageUrl}
                            alt={name}
                            className="cs-card-photo"
                            onError={e => {
                                (e.currentTarget as HTMLImageElement).style.display = 'none';
                                const wrap = e.currentTarget.parentElement;
                                if (wrap) {
                                    wrap.classList.remove('cs-card-img-wrap--photo');
                                    wrap.classList.add(gradientClass);
                                }
                            }}
                        />
                        <div className="cs-card-img-overlay" />
                    </>
                ) : (
                    <span className="cs-card-icon" role="img" aria-label={name}>
                        {DEFAULT_ICON}
                    </span>
                )}
            </div>
            <div className="cs-card-body">
                <span className="cs-card-name">{name}</span>
                <span className="cs-card-arrow" aria-hidden="true">
                    <ChevronRight />
                </span>
            </div>
        </Link>
    );
};

export default CategoryCard;
